
import { defineComponent } from "vue";
import { RouterLink, useRouter } from "vue-router";
import { useStore } from "vuex";
import OKRCheckerSideBar from "@/components/OKRCheckerSideBar.vue";

export default defineComponent({
  name: "OKRCheckerStart",
  components: {
    RouterLink,
    OKRCheckerSideBar,
  },
  setup() {
    const router = useRouter();
    const store = useStore();

    if (!store.getters.isLoggedIn) {
      router.push("/");
    }

    return {
      router,
      store,
    };
  },
  data() {
    return {
      errorMessage: "",
    };
  },
  methods: {
    async logout() {
      await this.handleLogout();
      if (!this.errorMessage) {
        this.router.push("/");
      }
    },

    async handleLogout() {
      // Send the POST request
      const response = await fetch("/api/logout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      // Get the response data
      const data = await response.json();

      // Check the response data
      if (data.message !== "User logged out") {
        this.errorMessage = data.message;
      } else {
        this.router.push("/");
        this.store.dispatch("logout");
      }
    },
  },
});
